import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/Button';

interface DeleteCaseDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  caseName: string;
  documentCount: number;
  onConfirm: () => void;
  isDeleting: boolean;
}

export function DeleteCaseDialog({
  open,
  onOpenChange,
  caseName,
  documentCount,
  onConfirm,
  isDeleting,
}: DeleteCaseDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Move Case to Trash</DialogTitle>
          <DialogDescription>
            This will move '{caseName}' and its {documentCount} document{documentCount !== 1 ? 's' : ''} to trash. You can restore it within 14 days.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            className="bg-red-600 hover:bg-red-700 text-white"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Moving...' : 'Move to Trash'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
